/**
 * @fileoverview PUT handler for the "/decisioning_studio_agents/:app_group_id/:id" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { decisioningStudioAgentsAppGroupIdIdCacheKeys } from "./constants";
import type {
  DecisioningStudioAgentUpdateFields,
  PutDecisioningStudioAgentsAppGroupIdIdProps,
  PutDecisioningStudioAgentsAppGroupIdIdResult,
} from "./types";

export const putDecisioningStudioAgentsAppGroupIdId = reactQueryMutationAdapter(
  decisioningStudioAgentsAppGroupIdIdCacheKeys,
  ({
    appGroupId,
    id,
    frequency_cap,
    exclude_from_global_frequency_count,
    direct_audience,
    signal,
  }: PutDecisioningStudioAgentsAppGroupIdIdProps): Promise<PutDecisioningStudioAgentsAppGroupIdIdResult> => {
    const dsa: DecisioningStudioAgentUpdateFields = {};

    if (frequency_cap !== undefined) {
      dsa.frequency_cap = frequency_cap;
    }
    if (exclude_from_global_frequency_count !== undefined) {
      dsa.exclude_from_global_frequency_count = exclude_from_global_frequency_count;
    }
    if (direct_audience !== undefined) {
      dsa.direct_audience = direct_audience;
    }

    return fetch(
      `/decisioning_studio_agents/${appGroupId}/${id}`,
      "PUT",
      {
        dsa,
      },
      signal ? { signal } : undefined
    );
  }
);
